import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, Router } from '@angular/router';
import { LogUtil } from '../utils/log.util';
import { FUNCTIONARY_LOGIN_STORAGE_NAME, USER_TOKEN_STORAGE_NAME } from '../constants/storage.constant';
import { DBService } from '../services/db.service';

@Injectable({
	providedIn: 'root'
})
export class LoginGuard implements CanLoad {

	constructor(
		private _router: Router,
		private _dbService: DBService
	) { }

	async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
		const functionaryLogin = await this._dbService.get(FUNCTIONARY_LOGIN_STORAGE_NAME);
		const token = await this._dbService.get(USER_TOKEN_STORAGE_NAME);

		// si en los segmentos de url existe el path "functionary", significa que ya tenemos en el primer login
		// por lo que debemos verificar si mostramos el login de functionary o no.
		if (segments.find(s => s.path.toLowerCase() == 'functionary')) {
			// si ya se loggeó como funcionary, entonces continuamos
			// y no permitimos mostrar /login/functionary.


			if (functionaryLogin && token) {
				LogUtil.sendLog('Login guard Functionary exists');
				this._router.navigateByUrl('/tabs');
				return false;
			}

			// damos permis para mostrar login de funcionario solo si no está logeado el funcionario y si existe token.
			if (!functionaryLogin && token) {
				return true;
			}

			// si no existe token y no está logeado el funcionario, debemos ir al login principal
			this._router.navigateByUrl('/login');
			return false;
		}

		// si en los segmentos de url no existe el path "funcionary", significa que vamos a intentar entrar al primer login.
		if (token) {
			// si ya existe token, vamos al login functionary
			LogUtil.sendLog('Login guard token exists');
			this._router.navigateByUrl('/login/functionary');
			return false;
		}
		// si no existe token, damos permiso para mostrar el login inicial
		LogUtil.sendLog('Login guard no token');
		return true;
	}
}
